import type { ReactNode } from 'react'

interface EmptyStateProps {
  /** Icon to display (optional) */
  icon?: ReactNode
  /** Title for the empty state */
  title: string
  /** Description explaining why this is empty or what to do */
  description?: string
  /** Call-to-action button or other actions */
  action?: ReactNode
}

/**
 * Empty state placeholder for lists with no items.
 */
export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      {icon && (
        <div className="mb-4 text-muted-foreground">{icon}</div>
      )}
      <h3 className="text-lg font-semibold text-foreground">{title}</h3>
      {description && (
        <p className="mt-1 max-w-sm text-sm text-muted-foreground">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
